import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssignmentRules } from '../../../shared/models/common/assigmentRules/assignmentRules';
import { AssignmentRulesEvent } from '../../../shared/models/common/assigmentRules/assignmentRulesEvent';
import { EditAssignmentRuleInput } from '../../../shared/models/common/assigmentRules/editAssignmentRules.input';
import { AssignmentRulesService } from '../../../shared/services/assignmentRules/assignment-rules.service';
import { EventService } from '../../../shared/services/event/event.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../shared/services/utils/translator.service';
import { AssignmentRulesComunicationService } from '../../profile/assignment-rules-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-edit-assignment-rules',
  templateUrl: './edit-assignment-rules.component.html',
  styleUrls: ['./edit-assignment-rules.component.scss']
})

export class EditAssignmentRulesComponent implements OnInit, AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;

  editAssignmentRuleInput: EditAssignmentRuleInput = new EditAssignmentRuleInput();
  loadingData = true;
  assignmentRule: AssignmentRules;
  title: string;
  userSelected: any;
  brandSelected: any;
  channelSelected: any;
  activeRulesSelected: any;
  dealerSelected: any;
  typeSelected: any;
  originAutocomplete: any;
  originSelected: any;
  assignmentRuleForm: any;
  JSON: JSON;
  sending = false;
  POSTAL_CODE_COUNTRY = 'es';
  zipCode: any;
  leadPostalCode: any;

  constructor(
    private readonly modalService: NgbModal,
    private readonly modalsHandler: ModalsHandlerService,
    private readonly translator: TranslatorService,
    protected formBuilder: FormBuilder,
    private readonly assignmentRulesService: AssignmentRulesService,
    private readonly toastService: ToastService,
    protected assignmentRulesComunicationService: AssignmentRulesComunicationService,
    private eventService: EventService,

  ) { }

  ngAfterViewInit(): void {
    this.modalsHandler.editAssignmentRuleModal.subscribe(assignmentRule => {
      this.open(this.content);

      this.assignmentRule = assignmentRule;
      this.loadingData = false;

      this.assignmentRuleForm = this.formBuilder.group({
        name: ['', [Validators.required]],
        postalCode: [],
      });

      this.setValues(assignmentRule);
    });
  }

  private setValues(assignmentRule: AssignmentRules) {
    this.zipCode = '';
    this.brandSelected = assignmentRule.brand;
    this.channelSelected = assignmentRule.channel;
    this.dealerSelected = assignmentRule.dealer;
    this.activeRulesSelected = assignmentRule.negativeRule ? { id: '0', name: this.translator.trans('response.no') } : { id: '1', name: this.translator.trans('response.yes') };
    this.userSelected = assignmentRule.user;
    if (assignmentRule.postalCode) {
      this.zipCode = assignmentRule.postalCode;
    }
    this.originSelected = assignmentRule.origin;
    this.leadPostalCode = assignmentRule.postalCode;

    const editAssignmentRuleInput = new EditAssignmentRuleInput(assignmentRule);
    this.typeSelected = {
      id: assignmentRule.leadType,
      name: this.translator.trans(`pages.leads.type.${assignmentRule.leadType}`)
    };

    this.editAssignmentRuleInput = editAssignmentRuleInput.getAssignmentRuleForm();
    this.assignmentRuleForm.patchValue(assignmentRule);
  }

  private open(content: any) {
    this.modalService
      .open(content, {
        size: 'lg',
        container: 'nb-layout',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static', keyboard: false,
        backdropClass: 'app-session-modal-backdrop',
        windowClass: 'app-session-modal-window'
      }).result.finally(() => {
        this.assignmentRule = null;
      });
  }

  ngOnInit(): void {
    this.zipCode = '';
    this.title = this.translator.trans('modals.assignmentrule.edit.title');
  }

  isValidForm(): boolean {
    if (!this.assignmentRuleForm.get('name').hasError('required')) {
      return true;
    }

    return false;
  }

  clearModal() {
    this.zipCode = '';
  }

  processForm(dropDownBrandItems?: any, dropDownChannelItems?: any, dropDownDealerItems?: any,
    dropDownTypeItems?: any, origin?: any, postalCodeAutocomplete?: any, dropDownUserItems?: any, dropDownActiveRules?: any): void {

    if (!this.isValidForm()) {
      return;
    }

    this.editAssignmentRuleInput.id = this.assignmentRule.id;
    this.editAssignmentRuleInput.name = this.assignmentRuleForm.controls.name.value;
    this.editAssignmentRuleInput.user = dropDownUserItems.map(user => user.id)[0];
    this.editAssignmentRuleInput.brand = dropDownBrandItems.map(brand => brand.id)[0];
    this.editAssignmentRuleInput.channel = dropDownChannelItems.map(channel => channel.id)[0];
    this.editAssignmentRuleInput.dealer = dropDownDealerItems.map(dealer => dealer.id)[0];
    this.editAssignmentRuleInput.leadType = dropDownTypeItems.map(type => type.id)[0];
    this.editAssignmentRuleInput.origin = origin;
    this.editAssignmentRuleInput.negativeRule = !dropDownActiveRules;
    this.editAssignmentRuleInput.postalCode = this.assignmentRuleForm.controls.postalCode.value;

    this.assignmentRulesService.editAssignmentRule$(this.editAssignmentRuleInput).subscribe(data => {
      if (data.data.editAssignmentRule) {
        this.successToastAndResponse();
        this.eventService.broadcast(AssignmentRulesEvent.ASSIGNMENT_RULE_EDITED);
        this.modalService.dismissAll();
      } else {
        this.repeatRuleToastAndResponse();

        this.modalService.dismissAll();
      }
    }, () => {
      this.failToastAndResponse();
    });
  }

  private failToastAndResponse() {
    this.toastService
      .showToast(
        'error',
        'toaster.lead.assignmentrule.error',
        'toaster.lead.assignmentrule.error.body'
      );
    this.sending = false;
  }

  private successToastAndResponse() {
    this.sending = true;
    this.toastService
      .showToast(
        'success',
        'toaster.lead.assignmentrule.success',
        'toaster.lead.assignmentrule.success.body'
      );
    this.sending = false;
  }

  private repeatRuleToastAndResponse() {
    this.sending = true;
    this.toastService
      .showToast(
        'error',
        'toaster.lead.assignmentrule.repeat',
        'toaster.lead.assignmentrule.repeat.body'
      );
    this.sending = false;
  }
}
